// @flow

import {Tag, findMarkdocTag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const NextStepsTag: MarkdocTagRegistration = {
  tag: 'next-steps',
  component: 'NextSteps',
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);

    // Require all next step components to use the guide list type
    const child = findMarkdocTag(children, (c) => c.name === 'List');

    if (child) {
      child.attributes.type = 'guide';
    }

    return new Tag(this.tag, attributes, children);
  },
};
